<template>
  <div class="dashboard-container">
    <el-card
      shadow="never"
      class="card-fix-height"
      header="数据统计"
      :style="{ 'max-height': '15rem' }"
    >
      <el-row class="statistics" :gutter="20">
        <el-col :span="6">
          <div class="pro" :style="'background-image: url(' + bg1 + ')'">
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ statisticsResult.totalUser }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 15px;right: 20px;color: #FFFFFF;"
            >
              入库人数
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="pro" :style="'background-image: url(' + bg2 + ')'">
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ statisticsResult.totalCertificate }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 15px;right: 20px;color: #FFFFFF;"
            >
              证书总数
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="pro" :style="'background-image: url(' + bg3 + ')'">
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ statisticsResult.totalHasCertificateUser }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 15px;right: 20px;color: #FFFFFF;"
            >
              发证人数
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      shadow="never"
      class="card-fix-height"
      header="人员入库数量统计"
      v-if="statisticsResult.totalUser"
    >
      <el-form :inline="true">
        <el-form-item>
          <el-date-picker
            v-model="datePicker1"
            type="daterange"
            :picker-options="pickerOptions1"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onGetUser" icon="el-icon-search"
            >查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="userVisable = true"
            icon="el-icon-s-operation"
            style="background-color: #ff5b4f"
            >列表
          </el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <div>
          <chart
            ref="userChart"
            style="width: 100%;"
            :options="userOptions"
            :auto-resize="true"
          ></chart>
        </div>
      </el-row>
    </el-card>
    <el-card
      shadow="never"
      class="card-fix-height"
      header="证书发放数量统计"
      v-if="statisticsResult.totalUser"
    >
      <el-form :inline="true">
        <el-form-item>
          <el-date-picker
            v-model="datePicker2"
            type="daterange"
            :picker-options="pickerOptions2"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onGetCer" icon="el-icon-search"
            >查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="cerVisable = true"
            icon="el-icon-s-operation"
            style="background-color: #ff5b4f"
            >列表
          </el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <div>
          <chart
            ref="cerChart"
            style="width: 100%;"
            :options="cerOptions"
            :auto-resize="true"
          ></chart>
        </div>
      </el-row>
    </el-card>
    <el-card
      shadow="never"
      class="card-fix-height"
      v-if="statisticsResult.totalUser"
    >
      <el-row class="charts">
        <el-col :span="8">
          <template
            v-if="
              statisticsResult &&
                statisticsResult.certificateType &&
                statisticsResult.certificateType.length > 0
            "
          >
            <chart
              ref="cerType"
              :options="cerTypeOptions"
              :auto-resize="true"
            ></chart>
          </template>
          <template v-else>
            <div
              style="height: 400px;width: 100%;justify-content: center;display: flex;align-items: center"
            >
              证书类型分布图暂无数据
            </div>
          </template>
        </el-col>
        <el-col :span="8">
          <chart
            ref="eduChart"
            :options="eduOptions"
            :auto-resize="true"
          ></chart>
        </el-col>
        <el-col :span="8">
          <chart
            ref="ageChart"
            :options="ageOptions"
            :auto-resize="true"
          ></chart>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog :visible.sync="userVisable">
      <el-table :data="userResult">
        <el-table-column prop="name" label="合作机构"> </el-table-column>
        <el-table-column prop="count" label="入库用户数量"> </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="cerVisable">
      <el-table :data="cerResult">
        <el-table-column prop="name" label="合作机构"> </el-table-column>
        <el-table-column prop="count" label="证书发放数量"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { statistics, user, hasCertificateUser } from "@/api/statistics";
import { getAllMapListMetaData } from "@/api/userInfo";
import bg1 from "../../assets/image/img01.png";
import bg2 from "../../assets/image/img02.png";
import bg3 from "../../assets/image/img03.png";
import Echarts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
export default {
  name: "dashboard",
  components: {
    chart: Echarts
  },
  computed: {},
  data() {
    return {
      metaData: {},
      cerOptions: {},
      userOptions: {},
      eduOptions: {},
      ageOptions: {},
      cerTypeOptions: {},
      statisticsResult: {},
      userResult: {},
      cerResult: {},
      userVisable: false,
      cerVisable: false,
      bg1: bg1,
      bg2: bg2,
      bg3: bg3,
      datePicker1: "",
      datePicker2: "",
      pickerOptions1: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getAllMapListMetaData();
  },
  methods: {
    getAllMapListMetaData() {
      getAllMapListMetaData().then(res => {
        if (res && res.code === "200") {
          this.metaData = res.data;
          this.statistics();
          this.user();
          this.hasCertificateUser();
        }
      });
    },
    onGetUser() {
      this.user();
    },
    onGetCer() {
      this.hasCertificateUser();
    },
    formatDate(d) {
      let date = new Date(d);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return [year, month, day].map(this.formatNumber).join("-") + " 00:00:00";
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    statistics() {
      let that = this;
      statistics().then(res => {
        if (res && res.code === "200") {
          that.statisticsResult = res.data;
          that.initAgeOption();
          that.initCerTypeOption();
          that.initEduOption();
        }
      });
    },
    user() {
      let that = this;
      let date = {
        startDate: "",
        endDate: ""
      };
      if (this.datePicker1 instanceof Array) {
        date.startDate = that.formatDate(that.datePicker1[0]);
        date.endDate = that.formatDate(that.datePicker1[1]);
      }
      user(date).then(res => {
        if (res && res.code === "200") {
          that.userResult = res.data.map(item => {
            if (!item.name) {
              item.name = "无代理商";
            }
            return item;
          });
          that.userResult.sort((a, b) => {
            return a.count < b.count ? 1 : -1;
          });
          that.initUserOption();
        }
      });
    },
    hasCertificateUser() {
      let that = this;
      let date = {
        startDate: "",
        endDate: ""
      };
      if (this.datePicker2 instanceof Array) {
        date.startDate = that.formatDate(that.datePicker2[0]);
        date.endDate = that.formatDate(that.datePicker2[1]);
      }
      hasCertificateUser(date).then(res => {
        if (res && res.code === "200") {
          that.cerResult = res.data.map(item => {
            if (!item.name) {
              item.name = "无代理商";
            }
            return item;
          });
          that.cerResult.sort((a, b) => {
            return a.count < b.count ? 1 : -1;
          });
          that.initCerOption();
        }
      });
    },
    initAgeOption() {
      if (this.statisticsResult.age && this.statisticsResult.age.length > 0) {
        let data = this.statisticsResult.age.map(item => {
          let obj = {};
          obj.name = item.name;
          obj.value = item.count;
          return obj;
        });
        this.ageOptions = {
          title: {
            text: "用户年龄分布",
            x: "center",
            bottom: "0"
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c}人 ({d}%)"
          },
          color: [
            "#FF5B4F",
            "#F68134",
            "#FFC000",
            "#FEC978",
            "#7BC98F",
            "#9D96BF",
            "#6DC4E2",
            "#F1978D"
          ],
          series: [
            {
              type: "pie",
              radius: "50%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        };
      }
    },
    initCerRatioOption() {
      let placeHolderStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          color: "rgba(0,0,0,0)",
          borderWidth: 0
        },
        emphasis: {
          color: "rgba(0,0,0,0)",
          borderWidth: 0
        }
      };
      let dataStyle = {
        normal: {
          formatter: "{c}%",
          position: "center",
          show: true,
          textStyle: {
            fontSize: "20",
            fontWeight: "normal",
            color: "#34374E"
          }
        }
      };
      this.cerRatioOptions = {
        backgroundColor: "#fff",
        title: {
          text: "发放证书比例",
          x: "center",
          bottom: "0"
        },
        series: [
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["50%", "30%"],
            center: ["50%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              normal: {
                position: "center"
              }
            },
            data: [
              {
                value: (
                  (this.statisticsResult.totalHasCertificateUser /
                    this.statisticsResult.totalUser) *
                  100
                ).toFixed(2),
                itemStyle: {
                  normal: {
                    color: "#ffe3e0"
                  }
                }
              }
            ]
          },
          //上层环形配置
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["50%", "30%"],
            center: ["50%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              normal: {
                position: "center"
              }
            },
            data: [
              {
                value: (
                  (this.statisticsResult.totalHasCertificateUser /
                    this.statisticsResult.totalUser) *
                  100
                ).toFixed(2),
                itemStyle: {
                  normal: {
                    color: "#ff584f"
                  }
                },
                label: dataStyle
              },
              {
                value: (
                  100 -
                  (this.statisticsResult.totalHasCertificateUser /
                    this.statisticsResult.totalUser) *
                    100
                ).toFixed(2),
                itemStyle: placeHolderStyle
              }
            ]
          }
        ]
      };
    },
    initCerTypeOption() {
      let that = this;
      if (
        that.statisticsResult.certificateType &&
        that.statisticsResult.certificateType.length > 0
      ) {
        let data = that.statisticsResult.certificateType.map(item => {
          let obj = {};
          obj.name = item.name;
          obj.value = item.count;
          return obj;
        });
        that.cerTypeOptions = {
          title: {
            text: "证书类型分布",
            x: "center",
            bottom: "0"
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)"
          },
          color: [
            "#FF5B4F",
            "#F68134",
            "#FFC000",
            "#FEC978",
            "#7BC98F",
            "#9D96BF",
            "#6DC4E2",
            "#F1978D"
          ],
          series: [
            {
              type: "pie",
              radius: "50%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        };
      }
    },
    initEduOption() {
      let that = this;
      if (
        that.statisticsResult.education &&
        that.statisticsResult.education.length > 0
      ) {
        let data = that.statisticsResult.education.map(item => {
          let name = {
            metaName: "未填写"
          };
          if (item.name) {
            name = that.metaData.education.find(e => {
              return item.name === e.metaCode;
            });
          }
          let obj = {};
          obj.name = name.metaName;
          obj.value = item.count;
          return obj;
        });
        that.eduOptions = {
          title: {
            text: "用户学历分布",
            x: "center",
            bottom: "0"
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c}人 ({d}%)"
          },
          color: [
            "#FF5B4F",
            "#F68134",
            "#FFC000",
            "#FEC978",
            "#7BC98F",
            "#9D96BF",
            "#6DC4E2",
            "#F1978D"
          ],
          series: [
            {
              type: "pie",
              radius: "50%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        };
      }
    },
    initUserOption() {
      let labels = [];
      let count = [];
      this.userResult.map(item => {
        if (labels.length < 10) {
          if (item.name) {
            labels.push(item.name);
          } else {
            labels.push("无代理商");
          }
          count.push(item.count);
        }
      });
      this.userOptions = {
        title: {
          text: "人员入库数量统计",
          left: "center",
          top: "0"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          }
        },
        xAxis: {
          data: labels,
          axisLabel: {
            //重点在这一块，其余可以忽略
            interval: 0, //这个一定要有，别忘记了
            rotate: 15,
            textStyle: {
              color: "#000",
              fontSize: 10
            }
          }
        },
        yAxis: {},
        series: [
          {
            type: "bar",
            data: count,
            barWidth: 30,
            itemStyle: {
              normal: {
                color: "#ff5b4f",
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
    },
    initCerOption() {
      let labels = [];
      let count = [];
      this.cerResult.map(item => {
        if (labels.length < 10) {
          if (item.name) {
            labels.push(item.name);
          } else {
            labels.push("无代理商");
          }
          count.push(item.count);
        }
      });
      this.cerOptions = {
        title: {
          text: "证书发放数量统计",
          left: "center",
          top: "0"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          }
        },
        xAxis: {
          data: labels,
          axisLabel: {
            //重点在这一块，其余可以忽略
            interval: 0, //这个一定要有，别忘记了
            rotate: 15,
            textStyle: {
              color: "#000",
              fontSize: 10
            }
          }
        },
        yAxis: {},
        series: [
          {
            type: "bar",
            data: count,
            barWidth: 30,
            itemStyle: {
              normal: {
                color: "#ff5b4f",
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard-container {
  &-container {
    /*display: flex;*/
    justify-content: center;
    min-height: calc(100vh - 114px);
    /*background: url("~@/assets/Group@2x.png") no-repeat;*/
    background-size: 100% 100%;
  }
  &-text {
    height: 40px;
    font-size: 2.5vh;
    font-family: AlibabaPuHuiTiR;
    color: rgba(17, 17, 17, 1);
    line-height: 40px;
    margin-top: 28vh;
  }
  .statistics {
    .el-col {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .pro {
        list-style: none;
        display: inline-block;
        position: relative;
        width: 320px;
        height: 80px;
        background-size: 100% 100%;
        margin: 0 12px;
        .el-row {
          margin: 10px 0;
        }
      }
    }
  }
  /deep/ .charts .echarts {
    width: 400px;
  }
}
</style>
